import { Button, Divider, Link, Stack, TextField, Typography } from "@mui/material"
import { useFormik } from "formik"
import FileUploadField from "../../../components/FileUploadField"


const StudentTaskForm = ({ canEdit, data, onSave, acceptedFiles, onAddAcceptedFiles, onRemoveAcceptedFile }) => {

    const { values, handleChange, handleSubmit } = useFormik({
        initialValues: data,
        enableReinitialize: true,
        onSubmit: onSave,
    })

    return <Stack direction="column" width="100%" spacing={2} mb={4}>

        <Typography variant="h6">
            {data?.name}
        </Typography>

        <Typography alignSelf="start" textAlign="justify">
            {data.task_text}
        </Typography>

        {data.files.length > 0 && <>
            <Divider />
            <Typography>
                Прикрепленные файлы
            </Typography>
            <Stack direction="column">
                {data.files.map(file => <Link key={file.id} href={file.link}>{file.name}</Link>)}
            </Stack>
        </>}

        <Divider />

        <FileUploadField
            disabled={!canEdit}
            acceptedFiles={acceptedFiles}
            onDrop={values => onAddAcceptedFiles(values.map(el => ({ file: el, task: data.id })))}
            onRemoveAcceptedFile={index => onRemoveAcceptedFile(({ index, task: data.id }))}
        />

        <TextField
            id="answer_text"
            name="answer_text"
            value={values.answer_text}
            onChange={handleChange}
            label="Ответ"
            multiline
            minRows={4}
            maxRows={8}
            fullWidth
            disabled={!canEdit}
        />

        <Button disabled={!canEdit} sx={{ mx: "auto" }} variant="contained" onClick={handleSubmit}>
            Сохранить
        </Button>
    </Stack>
}

export default StudentTaskForm